var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveItemIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.725 9.6504h-9.45c-0.3 0-0.525 0.225-0.525 0.52501v1.575c0 0.3 0.225 0.525 0.525 0.525h9.45c0.3 0 0.525-0.225 0.525-0.525v-1.575c0-0.22501-0.225-0.45001-0.525-0.52501z",
    fill: "#0000C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11 21.5c-5.775 0-10.5-4.725-10.5-10.5s4.725-10.5 10.5-10.5 10.5 4.725 10.5 10.5-4.725 10.5-10.5 10.5zm0-19.5c-4.95 0-9 4.05-9 9s4.05 9 9 9 9-4.05 9-9-4.05-9-9-9z",
    fill: "#0000C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveItemIcon);
export default __webpack_public_path__ + "static/media/removeItemIcon.14308c6d1486fbc5e455c79c1cfc5548.svg";
export { ForwardRef as ReactComponent };